import { render, staticRenderFns } from "./EntityMain.vue?vue&type=template&id=44d2e1a0&"
import script from "./EntityMain.vue?vue&type=script&lang=js&"
export * from "./EntityMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports